export enum ActionItemEnum {
  PortfolioReportClient = 0,
  CancelContribution = 1,
  CancelContributionProposal = 2,
  CancelPeriodicContributionProposal = 3,
  CancelWithdrawal = 4,
  CancelWithdrawalProposal = 5,
  ChangeModelPortfolio = 6,
  ChangeModelPortfolioProposal = 7,
  Contribution = 8,
  ContributionProposal = 9,
  FreeProposals = 10,
  OperatePortfolio = 11,
  PeriodicContributionProposal = 12,
  PortfolioProfile = 13,
  Proposals = 14,
  Sell = 15,
  Withdrawal = 16,
  WithdrawalProposal = 17,
  Buy = 18,
  AccountStatements = 19,
}
